import script from "./NotificationViewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationViewModal.vue?vue&type=script&setup=true&lang=js"

import "./NotificationViewModal.vue?vue&type=style&index=0&id=1076e4e7&lang=css"

const __exports__ = script;

export default __exports__